export default () => {
    const consumer = <HTMLInputElement>document.getElementById('billing_type_personal')
    const business = <HTMLInputElement>document.getElementById('billing_type_business')
    const company = <HTMLInputElement>document.getElementById('billing_company_field')
    const vat = <HTMLInputElement>document.getElementById('woocommerce_eu_vat_number_field')

    if (!vat || !company) {
        return
    }

    vat.classList.add('hidden');

    consumer.addEventListener('click', () => {
        company.style.display = consumer.checked ? 'none' : 'block';
        vat.classList.add('hidden');
    });

    business.addEventListener('click', () => {
        company.style.display = business.checked ? 'block' : 'none';
        vat.classList.remove('hidden');
    });
}